import { CSInterface } from "csinterface-ts";
const { csInterface }: { csInterface: CSInterface } = window as any;

export async function runJsxScript(script: string) {
  return new Promise((res, rej) => {
    csInterface.evalScript(script, (response: any) => {
      res(response);
    });
  });
}
